import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { slidesAdapter } from './slideAdapter'
import {
  editorInitialized,
  editorCleared,
  editorMerged,
  slideSyncFulfilled,
  slideReset,
  allChangesReset,
} from '../editorSync/actions'

const initialState = slidesAdapter.getInitialState()

export const slideSlice = createSlice({
  name: 'slides',
  initialState,
  reducers: {
    addDeletedLayerId(
      state,
      action: PayloadAction<{ slideId: number; layerId: number }>,
    ) {
      const slide = state.entities[action.payload.slideId]

      if (!slide) return

      slide.deletedLayerIds.push(action.payload.layerId)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editorInitialized, (state, action) => {
        slidesAdapter.setAll(state, action.payload.slides)
      })
      .addCase(editorCleared, () => initialState)
      .addCase(editorMerged, (state, action) => {
        // Add new slides
        for (const slide of action.payload.newSlides) {
          slidesAdapter.addOne(state, slide)
        }
      })
      .addCase(slideSyncFulfilled, (state, action) => {
        const slide = state.entities[action.payload.slideId]

        if (!slide) return

        slide.deletedLayerIds = []
      })
      .addCase(slideReset, (state, action) => {
        const slide = state.entities[action.payload.slideId]

        if (!slide) return

        slide.deletedLayerIds = []
      })
      .addCase(allChangesReset, (state) => {
        const allSlides = slidesAdapter.getSelectors().selectAll(state)

        allSlides.forEach((slide) => {
          const entity = state.entities[slide.id]

          if (!entity) return

          entity.deletedLayerIds = []
        })
      })
  },
})

export const { addDeletedLayerId } = slideSlice.actions
